import type { TreatmentListGroup, TreatmentTimelineStep } from '../../types/care';

export const LEAFLETS = 'https://excellentcareclinics.nl/wp-content/uploads/2026/08';

export const standardBring = [
  'Uw legitimatie- en verzekeringsbewijs',
  'Een overzicht van alle medicijnen die u (eventueel) gebruikt — op te vragen bij uw apotheek',
];

export const reportBasic = ['Zwangerschap', 'Gebruik van bloedverdunners', 'Allergieën'];
export const reportWithPacemaker = [...reportBasic, 'Pacemaker of ICD'];

export const bloodThinners =
  'Gebruikt u bloedverdunners? Mogelijk moet u hier tijdelijk mee stoppen. Dit bespreekt de pijnspecialist met u tijdens de intake. Bent u bekend bij de trombosedienst, geef dan aan hen door dat u tijdelijk stopt.';

export const standardComplications = [
  'Nabloeding',
  'Infectie — u herkent een infectie aan roodheid van de huid en koorts',
  'Allergische reactie',
];

export const corticosteroidSideEffects: TreatmentListGroup = {
  title: 'Bijwerkingen van de corticosteroïd',
  items: [
    'Koortsig gevoel, met name in het gelaat, en hoofdpijn',
    'Menstruatieklachten (de eerste maand mogelijk heviger dan normaal)',
    'Schommelende bloedsuikers bij insulineafhankelijke diabetes',
    'Stemmingswisselingen',
    'Anticonceptie kan gedurende één cyclus minder betrouwbaar zijn',
  ],
};

export const corticosteroidNote =
  'Deze bijwerkingen duren doorgaans een aantal dagen. Chirocaïne/Lidocaïne geeft geen bijwerkingen.';

export const injectionTimeline: TreatmentTimelineStep[] = [
  {
    when: 'Eerste uren tot een dag',
    text: 'Duidelijke pijnvermindering door de verdoving (Chirocaïne/Lidocaïne). Dit middel werkt snel in, maar ook weer snel uit — de pijn kan na de eerste dag terugkomen.',
  },
  {
    when: 'Dagen tot weken',
    text: 'De pijn neemt geleidelijk af door de irritatieremmer (corticosteroïd). Dit medicijn geeft uiteindelijk het meeste profijt, maar het duurt soms even voordat het merkbaar is.',
  },
  {
    when: 'Na ongeveer 8 weken',
    text: 'Het effect is goed te beoordelen. De behandeling wordt geëvalueerd en indien nodig worden vervolgstappen besproken.',
  },
];

export const injectionResult = ['Het resultaat is pas na enkele weken goed te beoordelen.'];

export const standardInjectionFacts = {
  home: 'Na ± 30 minuten',
  noDriving: true,
};
